import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60c7b312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "setting-main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 설정 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_8 = { class: "main_content" }
const _hoisted_9 = { class: "content_row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 간편 비밀번호 변경 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_bk.png",
  srcset: "/assets/icon/btn_right_bk@2x.png 2x,/assets/icon/btn_right_bk@3x.png 3x"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 본인인증을 다시 진행한 후 변경이 가능합니다. ", -1))
const _hoisted_14 = { class: "content_row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 개인정보 처리 동의 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_bk.png",
  srcset: "/assets/icon/btn_right_bk@2x.png 2x,/assets/icon/btn_right_bk@3x.png 3x"
}, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 개인정보 처리 동의 및 동의 현황 확인 (카카오클립 등) ", -1))
const _hoisted_19 = { class: "content_row" }
const _hoisted_20 = { class: "row_box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 마케팅 정보 수신 ", -1))
const _hoisted_22 = {
  key: 0,
  class: "row_info"
}
const _hoisted_23 = {
  key: 1,
  class: "row_info"
}
const _hoisted_24 = { class: "gray_content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_title" }, " 나의 정보 설정 ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 이메일 주소 수정 ", -1))
const _hoisted_27 = { class: "row_info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 이메일 주소 입력 ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 클럽딜 참여를 위해 이메일 주소를 입력해주세요. ", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 주소 수정 ", -1))
const _hoisted_32 = { class: "row_info" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 주소 입력 ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 조합참여 계약을 위해 주소정보가 필요합니다. ", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 은행계좌 수정 ", -1))
const _hoisted_37 = { class: "row_info" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 은행계좌 입력 ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "환불, 배당을 위한 본인 명의"),
  /*#__PURE__*/_createTextVNode(" 은행 계좌를 입력해주세요 ")
], -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 증권계좌 수정 ", -1))
const _hoisted_42 = { class: "row_info" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 증권계좌 입력 ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, [
  /*#__PURE__*/_createTextVNode(" 주식을 받을 수 있는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "본인 명의"),
  /*#__PURE__*/_createTextVNode(" 증권계좌를 입력해주세요 ")
], -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "bottom_wrap" }
const _hoisted_47 = { class: "btn_groups space-between" }
const _hoisted_48 = { class: "space-between black" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " · ", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "앱정보 v 2.0.1", -1))
const _hoisted_51 = { class: "delete_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_agree_to_use_personal_info = _resolveComponent("agree-to-use-personal-info")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_push_setting = _resolveComponent("push-setting")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[0] || (_cache[0] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'뒤로가기'})
                  _ctx.router.push({ path: '/tabs/mypage'})
                })
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _hoisted_6
                ])
              ])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "row_box",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'간편비밀번호변경'}); _ctx.askPassword()})
                }, _hoisted_12),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "row_box",
                  onClick: _cache[2] || (_cache[2] = () => {
                _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'개인정보처리동의'})
                _ctx.agreeModalOpen = true
              })
                }, _hoisted_17),
                _hoisted_18
              ]),
              _createVNode(_component_agree_to_use_personal_info, {
                "model-value": _ctx.agreeModalOpen,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.agreeModalOpen = $event)
              }, null, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_ion_toggle, {
                    mode: "ios",
                    style: {'--background-checked': '#4360EC', flexShrink: 0},
                    checked: _ctx.agreeMarketingValue === true || _ctx.agreeMarketingValue === 1? true : false,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'마케팅정보수신'}); _ctx.agreeMarketing()})
                  }, null, 8, ["checked"])
                ]),
                (_ctx.agreeMarketingValue === true || _ctx.agreeMarketingValue === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.formattedDate(_ctx.agreeMarketingAt)) + " 동의 완료 ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, " 조합, 회사 정보 받으시려면 동의해주세요.(선택) "))
              ]),
              _createVNode(_component_push_setting)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              (_ctx.email)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "white_wrap",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'이메일주소수정'}); _ctx.useRegistEmailModal()})
                  }, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.email), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "white_wrap",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'이메일주소입력'}); _ctx.useRegistEmailModal()})
                  }, _hoisted_30)),
              (_ctx.settingInfo.address1 && _ctx.settingInfo.address2)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "white_wrap",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'주소수정'}); _ctx.createModal('address')})
                  }, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.settingInfo.address1) + " " + _toDisplayString(_ctx.settingInfo.address2), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "white_wrap",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'주소입력'}); _ctx.createModal('address')})
                  }, _hoisted_35)),
              (_ctx.settingInfo.bankName && _ctx.settingInfo.bankAccount)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: "white_wrap",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'은행계좌수정'}); _ctx.createModal('account', 'refund')})
                  }, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.settingInfo.bankName.bankName) + " " + _toDisplayString(_ctx.settingInfo.bankAccount) + " " + _toDisplayString(_ctx.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: "white_wrap",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'은행계좌입력'}); _ctx.createModal('account', 'refund')})
                  }, _hoisted_40)),
              (_ctx.settingInfo.stockBankName && _ctx.settingInfo.stockBankAccount)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    class: "white_wrap",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'증권계좌수정'}); _ctx.createModal('account', 'stock')})
                  }, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.settingInfo.stockBankName.stockBankName) + " " + _toDisplayString(_ctx.settingInfo.stockBankAccount) + " " + _toDisplayString(_ctx.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 7,
                    class: "white_wrap",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'증권계좌입력'}); _ctx.createModal('account', 'stock')})
                  }, _hoisted_45))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  class: "common_btn white_btn",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'로그아웃'}); _ctx.logout()})
                }, " 로그아웃 "),
                _createElementVNode("button", {
                  class: "common_btn blut_btn",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'자주묻는질문'}); _ctx.openFAQModal('FAQ')})
                }, " 자주 묻는 질문 "),
                _createElementVNode("button", {
                  id: "custom-channel-io",
                  class: "common_btn navy_btn custom-channel-io",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'1:1문의'}); _ctx.openChannelTalk();})
                }, " 1:1 문의 ")
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'이용약관'});
                  _ctx.openLink('https://www.notion.so/angelleague/03d3a6fa9e0e41bb864d8289720bc52b')})
                  }, "이용약관"),
                  _hoisted_49,
                  _createElementVNode("span", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'개인정보처리방침'});
                  _ctx.openLink('https://www.notion.so/angelleague/cd4f32d98c4142f0858478c16de78c2f')})
                  }, "개인정보처리방침")
                ]),
                _hoisted_50
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("span", {
                  class: "red",
                  onClick: _cache[18] || (_cache[18] = () => {
                _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'회원탈퇴'})
                _ctx.router.push('/delete-account')
              })
                }, "회원탈퇴 >")
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}